import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { WORKER_TASK_REGISTERED } from '../../actionTypes/backendStatus';

/**
 * Records which worker a task runs on, as the API reported when the request was submitted.
 */
var registerWorkerTask = function registerWorkerTask(experimentId, taskName, workerGpuType) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: WORKER_TASK_REGISTERED,
              payload: {
                experimentId: experimentId,
                taskName: taskName,
                workerGpuType: workerGpuType
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default registerWorkerTask;